import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Containers/App/App';
import * as serviceWorker from './serviceWorker';
import 'react-dates/initialize';
import './fonts/BeVietnam-Regular.ttf'; 
import './fonts/BeVietnam-Bold.ttf'; 
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

// axios.interceptors.response.use(response => {
//     return response;
//  }, error => {
//    if (error.response.status === 401) {
//     console.log("alo 401!")
//     this.props.history.push("/")
//    }
//    return error;
//  });